
export let GET_ALL_COURSES_SUCCESS= "getAllCoursesSuccess";
export let GET_ALL_COURSES_FAILED= "getAllCoursesSuccess";
export let GET_ONE_COURSE_BY_ID_SUCCESS="getOneCourseByIdSuccess";
export let GET_ONE_COURSE_BY_ID_FAILED="getOneCourseByIdFailed";
